export default {"src":"/_next/static/media/wabi.48e2b3fa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};